import { useMutation } from '@tanstack/react-query';
import { useUser } from 'common/context/UserContext';
import { useApi } from 'common/hooks/api';
import { safeSingleMediaContentToUrl } from 'common/helpers/content';
import { ZAPS, savedItineraryTagLabel, MONTH_NAMES } from 'itrvl-types';
import { csvQuoteIds } from 'common/utils/itineraries';

// @todo: this could probably be moved to the backend
export const useClientPortalSharedZap = () => {
  const Api = useApi();
  const userContext = useUser();
  const mutation = useMutation({
    mutationFn: ({ itineraries }) => {
      Api.zap(ZAPS.CLIENT_PORTAL_SHARED, userContext, { quoteId: csvQuoteIds(itineraries) });
    },
  });
  return mutation;
};

// @todo: this could probably be moved to the backend
export const useImportBookingZap = () => {
  const Api = useApi();
  const userContext = useUser();
  const mutation = useMutation({
    mutationFn: ({ importId, quoteId, wwKey }) => {
      Api.zap(ZAPS.QUOTE_IMPORTED, userContext, { quoteId, wwKey }, `${window.location.origin}/itinerary/${importId}`);
    },
  });
  return mutation;
};

const fetchClientWwKey = async (Api, clientId) => {
  if (!clientId) return undefined;
  try {
    const { data } = await Api.get(
      `/api/Itineraries?filter=${JSON.stringify({ where: { clientId }, order: 'createdDate DESC', limit: 1, fields: ['wwKey'] })}`,
    );
    return data?.[0]?.wwKey;
  } catch {
    return undefined;
  }
};

export const useEdgeEnquiryZap = () => {
  const Api = useApi();
  const userContext = useUser();
  const mutation = useMutation({
    mutationFn: async ({ formData, renderData }) => {
      const agency = userContext?.user?.agency;
      const clientId = userContext?.client?.id;
      const wwKey = await fetchClientWwKey(Api, clientId);
      const payload = {
        'Wilderness Sales Email': agency?.consultantEmail,
        'Wilderness Operations Email': agency?.emails?.wildernessOperations,
        'Agency Sales Email': agency?.emails?.agencySales,
        'Agency Operations Email': agency?.emails?.agencyOperations,
        'Agency Dark Logo URL': safeSingleMediaContentToUrl(agency?.logoDark),
        'Agency Main Brand Color': agency?.backgroundColor,
        'Agency Button and Icon Color': agency?.secondaryThemeColor,
        'Example Itinerary Name': renderData?.itineraryName || renderData?.name || '',
        Destinations: formData.destinations?.join(', '),
        'Travel Months': formData.selectedMonths?.map(i => MONTH_NAMES[i]).join(', '),
        'Travel Year': formData.selectedYear,
        'Start Date': formData.startDate,
        'End Date': formData.endDate,
        'Trip Duration': formData.duration,
        'Date Mode': formData.dateMode,
        Adults: formData.adults,
        Children: formData.children,
        'Children Ages': formData.childrenAges?.join(', '),
        Budget: formData.budget,
        'Trip Types': formData.tripTypes?.map(savedItineraryTagLabel).join(', '),
        Notes: formData.notes,
      };
      return Api.zap(ZAPS.EDGE_ENQUIRY, userContext, { wwKey }, window.location.href, payload, { merge: true });
    },
  });
  return mutation;
};
